import React from "react";

const Details = (props) => {
  return (
    <div>
      <h3>{props.cart}</h3>
    </div>
  );
};

export default Details;
